<template>
<div class="inline">
<template v-if="data.length>1">
	<Tag  :value="thename+'\xa0\xa0\xa0\xa0 +'+(data.length-1)" class="mr-2 mb-2" v-tooltip.left="{ value:tooltiptext, disabled: false,class: 'custom-top-tooltip' }" />


</template>
<template v-else>
	<Tag  :value="thename" class="mr-2 mb-2" />
</template>
</div>
</template>

<script>
export default {

  name: 'TableTag',
  props:["data","type"],
  data () {
    return {

    }
  },
  computed:{
  	thename()
  	{
  		if(this.type=="flow")
  		{
  			if(this.data[0].flow)
  			{
  				return this.data[0].flow.name
  			}
  			
  		}
  		else
  		{
  			let name = this.getTheTranslation(this.data[0].project,"translation")
  			return name
  		}
  	},
  	tooltiptext()
  	{
  		let text  = ""
  		if(this.data.length>1)
  		{
  			
  			for (let i = 0; i < this.data.length; i++) {
				  if(i==this.data.length)
				  {
				  	if(this.type=="flow")
				  	{
				  		if(this.data[i].flow)
				  		{
				  			text = text+this.data[i].flow.name
				  		}
				  		
				  	}
				  	else
				  	{
				  		text = text+this.data[i].project.name
				  	}
				  	
				  }
				  else
				  {
				  	if(this.type=="flow")
				  	{
				  		if(this.data[i].flow)
				  		{
				  			text = text+this.data[i].flow.name+",\n"
				  		}
				  		
				  	}
				  	else
				  	{
				  		text = text+this.data[i].project.name+",\n"
				  	}
				  }
				}
  		}
  		return text
  	}
  }
}
</script>

<style lang="css" scoped>
</style>